// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

const UndergroundPure = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10">
    <path
      fill="currentColor"
      d="M0 10v-1.3h.78l3.5-8.7 2.72 5.37 2.72-5.37 3.5 8.7h.78v1.3h-4.86v-1.3h.78l-.78-2.77-2.14 2.77-2.14-2.77-.78 2.77h.78v1.3z"
    />
  </svg>,
);

export const UndergroundIcon: React.SFC<React.CSSProperties> = (props: React.CSSProperties) => (
  <UndergroundPure style={{ ...props }} />
);

UndergroundIcon.displayName = 'UndergroundIcon';
